module.exports = __webpack_public_path__ + "static/img/10bg_8.6a0182a.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/10bg_8.png
// module id = 624
// module chunks = 1